module.exports = __webpack_public_path__ + "static/media/3786.92f5dc8c.jpg";